import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { TicketService } from 'src/app/services/ticket.service';
import { ModalField } from 'src/app/modal/modal.component';

// Declare Flowbite Modal interface/class for TypeScript
declare var Modal: {
  new (targetEl: HTMLElement | null, options?: any): {
    hide(): void;
    // You might need to add other methods like show(), toggle() if you use them
  };
};
declare function initFlowbite(): void; // Declare the Flowbite function

@Component({
  selector: 'app-parametres',
  templateUrl: './parametres.component.html',
  styleUrls: ['./parametres.component.css'],
  providers: [MessageService],
})
export class ParametresComponent implements OnInit {
  user: any = null; // Stocke les infos utilisateur
  ticketAmount: number = 0;
  ticketForm: FormGroup;

  // Configuration for app-modal
  updateTicketValueModalId = 'updateTicketValueModal';
  ticketValueFields: ModalField[] = [
    {
      controlName: 'valeur',
      label: 'Nouveau montant (XOF)',
      type: 'number',
      placeholder: 'Entrer le nouveau montant',
      required: true,
    },
  ];

  constructor(
    private ticketService: TicketService,
    private fb: FormBuilder,
    private messageService: MessageService
  ) {
    this.ticketForm = this.fb.group({
      valeur: ['', [Validators.required, Validators.min(0)]],
    });
  }

  ngOnInit() {
    this.loadTicketAmount();
  }

  ngAfterViewInit(): void {
    // Add this lifecycle hook
    initFlowbite(); // Initialize Flowbite after the view is ready
  }

  private loadTicketAmount() {
    this.ticketService.getTicketAmount().subscribe({
      next: (amountObject) => {
        this.ticketAmount = amountObject.data.ticketAmount;
      },
      error: (error) => {
        console.error('Error loading ticket amount:', error);
        this.ticketAmount = 0; // Example default
      },
    });
  }

  checked: boolean = false;
  checked1: boolean = false;

  // Renamed from showDialog, pre-fills form before modal opens via data-modal-toggle
  // prepareUpdateTicketValueModal() {
  //   console.log('Modifier button clicked!'); // <-- Add this line
  //   this.ticketForm.patchValue({ valeur: this.ticketAmount });
  // }

  updateTicketAmount(submittedValue: any) {
    // Accept the emitted value
    //console.log('updateTicketAmount called');
    //console.log('Submitted Value:', submittedValue); // Log the received value
    // Now, instead of using this.ticketForm.valid/value, use submittedValue
    // We assume the modal already validated its own form before emitting
    if (
      submittedValue &&
      submittedValue.valeur !== undefined &&
      submittedValue.valeur !== null
    ) {
      // Check if the received value is valid
      const newAmount = submittedValue.valeur; // Get the value from the submitted object
      //console.log('newAmount:', newAmount);
      // The check for null/undefined might still be useful depending on type coercion
      // if (newAmount === null || newAmount === undefined ) { // Redundant check if type is number
      //   console.error('New amount value is invalid');
      //   this.messageService.add({ severity: 'warn', summary: 'Invalide', detail: 'Le nouveau montant est invalide.'});
      //   return;
      // }

      this.ticketService.updateTicketAmount(newAmount).subscribe({
        next: (response) => {
          this.ticketAmount = newAmount;
          this.messageService.add({
            severity: 'success',
            summary: 'Succès',
            detail: 'Le montant du ticket restaurant a été modifié avec succès',
          });

          // --- Close the modal ---
          const modalElement = document.getElementById(
            this.updateTicketValueModalId
          );
          if (modalElement) {
            try {
              // Get Flowbite modal instance and hide it
              const modal = new Modal(modalElement);
              modal.hide();

              // Optional: Remove backdrop manually if hide() doesn't
              const backdrop = document.querySelector('[modal-backdrop]');
              if (backdrop) {
                backdrop.remove();
              }
              // Optional: Reset body overflow if needed
              document.body.style.overflow = '';
            } catch (e) {
              console.error('Error hiding modal programmatically:', e);
            }
          } else {
            console.warn(
              `Modal element with ID '${this.updateTicketValueModalId}' not found.`
            );
          }
          // --- End closing modal ---
        },
        error: (error) => {
          console.error('Error updating ticket amount:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail:
              'Une erreur est survenue lors de la modification du montant du ticket restaurant, veuillez réessayer.',
          });
        },
      });
    } else {
      // Handle cases where the emitted value is invalid or doesn't have 'valeur'
      console.error(
        'Invalid submitted value received from modal:',
        submittedValue
      );
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Données du formulaire invalides.',
      });
    }
  }
}
